import { Redirect } from 'react-router-dom';
import { SUPER_ADMIN_DASHBOARD } from '../../config/constants/routePathConstants.js';

export const RedirectToAdminDashboard = () => {
  return <Redirect to={SUPER_ADMIN_DASHBOARD} />;
};

